export const ConfidenceLevel = ({ level, isDarkTheme = false }) => {
    const green = isDarkTheme ? "#24B98C" : "#43BC98";
    const grey = isDarkTheme ? "#3E4642" : "#C4CDCA";

    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="5" width="2.5" height="5" fill={green} />
            <rect x="3.75" y="2.5" width="2.5" height="7.5" fill={level > 1 ? green : grey} />
            <rect x="7.5" width="2.5" height="10" fill={level === 3 ? green : grey} />
        </svg>
    );
};
